/// <amd-module name="Environments/Providers/Kubernetes/KubernetesBreadcrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";

import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

export class KubernetesBreadcrumbService extends VssService implements IBreadcrumbItemService {

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setBreadcrumb(...items: { id: string, displayName: string, url: string }[]): void {
        this.items.removeAll();
        
        const breadcrumbItems: IBreadcrumbItem[] = items.map(item => getBreadcrumbItem(item, (l, e) => this._onFPSClick(l, e)));
        this.items.push(...breadcrumbItems);
    }

    private _onFPSClick = (link: string, ev?: React.MouseEvent<HTMLElement>) => {
        onClickFPS(this.pageContext, link, true, ev);
    }

    private items: ObservableArray<IBreadcrumbItem> = new ObservableArray<IBreadcrumbItem>();
}

function getBreadcrumbItem(item: { id: string, displayName: string, url: string }, onFPSClick: (link: string, ev?: React.MouseEvent<HTMLElement>) => void): IBreadcrumbItem {
    return {
        key: item.id,
        text: item.displayName,
        href: item.url,
        onClick: (ev: React.MouseEvent<HTMLElement>) => {
            onFPSClick(item.url, ev);
        }
    };

}

Services.add("KubernetesBreadcrumbService", { serviceFactory: KubernetesBreadcrumbService });
